export default {"src":"/_next/static/media/settings.85505007.svg","height":16,"width":16};